import React, { useState, useEffect } from "react"
import { Button, Modal } from "react-bootstrap"

import { withPlotSettingsConfig } from "../../../../config/PlotSettingsConfigProvider"
import {
  withRunEventLabelState,
  id_accessor,
  isLTPM,
} from "../../../../../components/shared_components_registration"
import { ColorBoxWithLabel } from "../../GraphComponents/CrossHairLayer/PointDataOverlay"
import { stringifyDate } from "../../../../utils"
import { updateObject } from "../../../../../Loaders"
import { logToServer } from "../../../../../ErrorBoundary"

const EditRunEventLabelModal = ({
  show,
  onHide,
  exportBaseName,
  run = {},
  editLabel,
  timeExtractor, // From PlotSettingsConfigProvider
  runEventRegistration, // From RunLabelConfigProvider
}) => {
  if (isLTPM) {
    return <></>
  }
  const { runEventLabels = [], name = "" } = run
  const [err, setErr] = useState("")
  const [showTrashed, setShowTrashed] = useState(false)
  const [runLabels, setRunLabels] = useState([])
  useEffect(() => {
    if (showTrashed) {
      setRunLabels(runEventLabels)
    } else {
      setRunLabels(runEventLabels.filter((l) => !l.is_trashed))
    }
  }, [showTrashed, runEventLabels])

  return (
    <Modal
      size={"lg"}
      dialogClassName={"definitions-modal"}
      show={show}
      onHide={onHide}
      style={{ overflowX: "scroll" }}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{`Event Labels: ${exportBaseName}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={"trashed-events-toggle form-check form-switch"} style={{ marginLeft: "auto" }}>
          <input
            type={"checkbox"}
            id={"trashed-events-toggle"}
            className={"form-check-input"}
            checked={showTrashed}
            onChange={() => setShowTrashed(!showTrashed)}
          />
          <label htmlFor={"trashed-events-toggle"} className={"form-check-label"}>
            Show deleted labels
          </label>
        </div>
        <div>
          {runLabels.map((l, i) => {
            const matchType = runEventRegistration.find((e) => e.name === l.event_type) || {}
            const colour = matchType?.default_color || "grey"
            const opacity = matchType?.opacity || 0.35
            return (
              <div
                key={`${name}label_${i}`}
                className={"solid-grey-border"}
                style={{
                  display: "flex",
                  margin: "0",
                  borderRadius: "5px",
                  padding: "10px",
                  backgroundColor: l.is_trashed ? "var(--lanzalake-red-light)" : "white",
                }}
              >
                <div className={"col-4"}>
                  <ColorBoxWithLabel
                    key={`${name}${i}editing`}
                    color={colour}
                    opacity={opacity}
                    text={l.event_type}
                  />
                  {l.display_option && <div>{`Option Selected: ${l.display_option}`}</div>}
                </div>
                <div className={"col-6 g-0"}>
                  <div>
                    {`Created By: ${l.created_by} [${stringifyDate(l.created_on, true, false, false)}]`}
                  </div>
                  {l.updated_by && (
                    <div>
                      {`Updated By: ${l.updated_by} [${stringifyDate(l.updated_on, true, false, false)}]`}
                    </div>
                  )}
                  <div>
                    Time Range: &nbsp;
                    {timeExtractor.name === "Timestamp"
                      ? `${stringifyDate(l.start_timestamp)} - ${
                          l.placeholder_end_date ? "now" : stringifyDate(l.end_timestamp)
                        }`
                      : `${l.start_day.toFixed(3)} - ${
                          l.placeholder_end_date ? "now" : l.end_day.toFixed(3)
                        }`}
                  </div>
                  {l.trashed_by && (
                    <div className={"warning-message"}>
                      {`Trashed By: ${l.trashed_by} [${stringifyDate(l.trashed_on, true, false, false)}]`}
                    </div>
                  )}
                </div>
                <div className={"col-2 text-end"}>
                  {!l.is_trashed && (
                    <Button
                      variant="outline-primary"
                      title="Edit Run Label"
                      onClick={() => {
                        editLabel({
                          editing_id: l.id,
                          min: timeExtractor.name === "Day" ? l.start_day : l.start_timestamp,
                          max: timeExtractor.name === "Day" ? l.end_day : l.end_timestamp,
                          placeholder_end_date: l.placeholder_end_date,
                          event_type: l.event_type,
                          selected_option: l.selected_option,
                          custom_option: l.custom_option,
                          option_confirmed: l.option_confirmed,
                          comment: l.comment,
                        })
                      }}
                    >
                      <i className="fa fa-pencil" />
                    </Button>
                  )}
                  <Button
                    variant="outline-primary"
                    title={l.is_trashed ? "Restore Run Event Label" : "Delete Run Event Label"}
                    onClick={() => {
                      updateObject(`/warehouse/runlabels/${run[id_accessor]}/trash_runreactor_label/`, {
                        id: l.id,
                        is_trashed: !l.is_trashed,
                      })
                        .then((_) => {
                          run.reloadRunEventLabels && run.reloadRunEventLabels()
                          setErr("")
                        })
                        .catch((err) => {
                          console.error(err)
                          logToServer(err)
                          setErr(
                            `There was an issue ${
                              l.is_trashed ? "restoring" : "deleting"
                            } the run event label`,
                          )
                        })
                    }}
                  >
                    <i className={l.is_trashed ? "fa fa-wrench text-success" : "fa fa-trash text-danger"} />
                  </Button>
                </div>
              </div>
            )
          })}
        </div>
      </Modal.Body>
      <Modal.Footer>
        {err && (
          <div>
            <span className={"error-message"} style={{ display: "block", marginBottom: "5px" }}>
              {err}
            </span>
          </div>
        )}
        <Button variant="outline-primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default withRunEventLabelState(withPlotSettingsConfig(EditRunEventLabelModal))
